import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const todoApiSlice = createApi({
  reducerPath: "todoApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://todo-json-backend.herokuapp.com",
  }),
  tagTypes: ["AllTodos", "CompleteTodos", "UnCompleteTodos"],
  endpoints: (builder) => ({
    getTodos: builder.query({
      query: (arg) => {
        let { complete, colorFilter } = arg || {};
        let queryStr = "";
        // Complete and Uncomplete filter
        if (complete) queryStr += "completed=true";
        else queryStr += "completed=false";
        // Color filter
        if (colorFilter && colorFilter?.length !== 0) {
          queryStr += `&color_like=${colorFilter.join("&color_like=")}`;
        }

        return `/todos?${queryStr}`;
      },
      providesTags: (result, error, arg) => {
        if (arg?.complete) return ["CompleteTodos", "AllTodos"];
        else return ["UnCompleteTodos", "AllTodos"];
      },
    }),
    addTodo: builder.mutation({
      query: (data) => ({
        url: `/todos`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: () => ["UnCompleteTodos"],
    }),
    updateTodo: builder.mutation({
      query: ({ id, data }) => ({
        url: `/todos/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, arg) => {
        if (arg?.RefetchAllTodos) return ["AllTodos"];
        else if (arg?.complete) return ["CompleteTodos"];
        else return ["UnCompleteTodos"];
      },
    }),
    deleteTodo: builder.mutation({
      query: ({ id }) => ({
        url: `/todos/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, arg) => {
        if (arg?.complete) return ["CompleteTodos"];
        else return ["UnCompleteTodos"];
      },
    }),
  }),
});

export const {
  useGetTodosQuery,
  useAddTodoMutation,
  useUpdateTodoMutation,
  useDeleteTodoMutation,
} = todoApiSlice;
